import { useState, useEffect } from "react";

import { NavLink } from "react-router-dom";
import CustomButton from "../kits/button/CustomButton.jsx";
import useAxios from "../../services/useAxios.tsx";
import CustomerList from "../customer-list/CustomerList.jsx";
import { ArrowLeftIcon } from "../kits/Icons";
import ColorSchema from "../kits/Color/index";

export default function CreditorCustomers({ tagOption }) {
  const { execute: getCustomers } = useAxios("api2/get_customers");
  const [customers, setCustomers] = useState([]);
  useEffect(() => {
    getCustomers().then((data) => {
      setCustomers(data.customers.filter((v) => v.amount_credit > 0));
    });
  }, []);
  return (
    <>
      <div className="d-flex">
        {" "}
        <div
          className="d-flex align-items-center ms-auto"
          style={{
            color: ColorSchema.primary_custom,
            borderBottom: `1px solid ${ColorSchema.primary_custom}`,
          }}
        >
          <NavLink to="/customer-list" className=" text-decoration-none px-1">
            <p color="info">مشاهده همه</p>
          </NavLink>
          <ArrowLeftIcon
            color={`${ColorSchema.primary_custom}`}
            style={{ width: 20, height: 20 }}
          />
        </div>
      </div>

      <div>
        <CustomerList
          content={customers}
          setContent={setCustomers}
          tagOption={tagOption}
        ></CustomerList>
      </div>
    </>
  );
}
